import React from 'react';
import { Link } from 'react-router-dom';
import { useRoleObject } from '../../../pages/arc/components/useRoles';
import { roleObjectMatch } from '../../helpers/auth-helpers';
import { TcsmActionBlock } from '../../models/tcsm-block-models';
import { ExternalLink } from '../external-link-modal';
import { BillingAccountSelectButton } from '../HOCs/with-billingaccount-select';
import { DividerSection } from '../layout/divider-section';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';


interface Props {
	blockData: TcsmActionBlock,
}

export const TcsmActionBlockView = (props: Props) => {

	const { blockData } = props;
	const roles = useRoleObject();
	const filteredByRole = blockData?.links?.filter(item => {
		return roleObjectMatch(item.rolesMatch, roles) > 0;		
	});
	return (
		<DividerSection removeDivider sectionText={blockData?.title}>
			<ContentSpacer>
				<WysiwygWithReactLink content={blockData?.description}></WysiwygWithReactLink>
			</ContentSpacer>
			<div className='quick-action-grid'>
				{
					filteredByRole?.map((a, idx) => {
						if (a?.externalLinkUrl?.uri?.includes('{account}')) {

							return <BillingAccountSelectButton key={idx} redirect={a?.externalLinkUrl?.uri} buttonText={a?.linkText} />;
						}

						return (
							a.externalLinkUrl ?
								<ExternalLink className='btn-secondary quick-action-btn' key={idx} linkText={a.linkText} linkUrl={a.externalLinkUrl?.uri || a.externalLinkUrl} />
								:
								<Link className='btn-secondary quick-action-btn' key={idx} to={a.linkUrl}>{a.linkText}</Link>
						);
					})
				}
			</div>
		</DividerSection>

	);

};


